import { UPDATE_VIEWPORT_DIMENSIONS, UPDATE_VIEWPORT_IS_MOBILE } from "src/store/constants/browser";

export type UpdateViewportActions = UpdateViewportDimensionsAction | UpdateViewportIsMobileAction;

export interface UpdateViewportDimensionsAction {
    data: { dimensions: { height: number; width: number } };
    type: UPDATE_VIEWPORT_DIMENSIONS;
}

export interface UpdateViewportIsMobileAction {
    data: { isMobile: boolean };
    type: UPDATE_VIEWPORT_IS_MOBILE;
}

export function updateViewportDimensions(data: {
    dimensions: { height: number; width: number };
}): UpdateViewportDimensionsAction {
    return {
        data,
        type: UPDATE_VIEWPORT_DIMENSIONS,
    };
}

export function updateViewportIsMobile(data: { isMobile: boolean }): UpdateViewportIsMobileAction {
    return {
        data,
        type: UPDATE_VIEWPORT_IS_MOBILE,
    };
}
